'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPanoramaHorizontal = function MdPanoramaHorizontal(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.7 6.6c0.6 0 0.9 0.4 0.9 1.1v24.6c0 0.7-0.3 1.1-0.9 1.1-0.2 0-0.3-0.1-0.5-0.2-4.9-1.8-10-2.7-15.2-2.7s-10.3 0.9-15.2 2.7c-0.2 0.1-0.4 0.2-0.5 0.2-0.6 0-0.9-0.5-0.9-1.1v-24.6c0-0.7 0.3-1.1 0.9-1.1 0.2 0 0.3 0.1 0.5 0.2 4.9 1.8 10 2.7 15.2 2.7s10.3-0.9 15.2-2.7c0.2-0.1 0.4-0.2 0.5-0.2z m-2.3 4.3c-4.3 1.4-8.9 1.9-13.4 1.9s-9.1-0.6-13.4-1.9v18.2c4.3-1.3 8.9-1.9 13.4-1.9s9.1 0.6 13.4 1.9v-18.2z' })
        )
    );
};

exports.default = MdPanoramaHorizontal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/panorama-horizontal.js
// module id = 3364
// module chunks = 0